// use-form.ts
import { Form } from "./form.js";
import { generateUseForm } from "./generic-use-form.js";
function useForm(documentInput, options = {}, deps) {
  return generateUseForm(Form)(documentInput, options, deps);
}
export {
  useForm
};
